import { clientConfig } from '@/config/clientConfig';
import { CollectionName, SerializedCollection, SerializedCollections } from '@/shared/lib/sj-orm';
import { DatabaseJsonData } from '@/shared/types/myhub';
import { log } from '@/shared/utils/log';

import { Loader } from './types';

let fetchJsonPromise: Promise<DatabaseJsonData> | null = null;

export class FileLoader implements Loader {
  async push(): Promise<boolean> {
    throw new Error('[FileLoader] push not implementer');
  }

  async pull(collectionName: CollectionName): Promise<SerializedCollection | null> {
    const data = await this.fetchDatabase();

    if (!data) {
      log.error('[FileLoader] error fetch database.json');
      return null;
    }

    // convert json to next format: [{[collectionName]: {data: string}}]
    const result = {} as SerializedCollections;

    for (const record of data.collections) {
      result[<CollectionName>record.name] = {
        data: JSON.stringify(record.data),
      };
    }

    log.trace(`[FileLoader] pull done. ${collectionName}`);
    return result[collectionName]?.data;
  }

  async fetchDatabase(): Promise<DatabaseJsonData | null> {
    if (!fetchJsonPromise) {
      const url = `${clientConfig.selfUrl}/database/database.json`;

      fetchJsonPromise = fetch(url)
        .then((response) => response.json())
        .catch(() => null);
    }

    return fetchJsonPromise;
  }
}
